import axios from "@/libs/axios";

export default {
    namespaced: true,
    state: {},
    getters: {},
    mutations: {},
    actions: {
        read(ctx, queryParams) {
            return new Promise((resolve, reject) => {
                axios
                    .get("/tags", { params: queryParams })
                    .then((response) => resolve(response.data))
                    .catch((error) => reject(error));
            });
        },
    },
};
